import React from "react"
import { GridContextProvider, GridDropZone, GridItem, swap } from "react-grid-dnd"
import Shortcut, { SHORTCUT_TYPE } from "../../state/shortcut/Shortcut"
import ShortcutActionComponent from "../components/ShortcutActionComponent"
import ShortcutFilterComponent from "../components/ShortcutFilterComponent"

function getWindowDimensions() {
    const {innerWidth: width} = window
    return {
        width
    }
}

const getGridNumberOfColumns = () => {
    const objectWidth = getWindowDimensions()
    if (objectWidth.width < 768) {
        return 1
    } else if (objectWidth.width < 992) {
        return 3
    } else {
        return 4
    }
}

interface Props {
    itemHeight?: number
    isEditable: boolean,
    locationId: string,
    shortcutsList: Shortcut[],
    shortcutType: SHORTCUT_TYPE
    handleShortcutsList: (shortcutType: SHORTCUT_TYPE, updatedShortcut: Shortcut, handleType: string) => void,
    onDragEnd: (shortcuts: Shortcut[]) => unknown,
}

const ShortcutsGrid: React.FC<Props> = ({
    isEditable,
    locationId,
    shortcutsList,
    shortcutType,
    onDragEnd,
    handleShortcutsList,
    itemHeight = 170
}) => {

    const numbOfRows = Math.ceil(shortcutsList.length / getGridNumberOfColumns())
    const totalHeight = itemHeight * numbOfRows

    const handleOnDragEnd = (_sourceId: string, sourceIndex: number, targetIndex: number) => {
        onDragEnd(swap(shortcutsList, sourceIndex, targetIndex))
    }

    const getShortcutComponentByType = (shortcutType: SHORTCUT_TYPE, shortcut: Shortcut) => {
        if (shortcutType === SHORTCUT_TYPE.FILTER) {
            return <ShortcutFilterComponent
                shortcut={shortcut}
                isEditable={isEditable}
                locationId={locationId}
                handleShortcutsList={handleShortcutsList}
            />
        } else {
            return <ShortcutActionComponent
                shortcut={shortcut}
                isEditable={isEditable}
                locationId={locationId}
                handleShortcutsList={handleShortcutsList}
            />
        }
    }

    if (!isEditable) {
        return (
            <div className={"row ui-has-modules px-1 pt-0"}>
                {shortcutsList.map((shortcut) => {
                    return (
                        <div className={"col-12 col-lg-3 col-md-4 col-sm-12"} key={shortcut.getId()}>
                            {
                                getShortcutComponentByType(shortcutType, shortcut)
                            }
                        </div>
                    )
                })}
            </div>
        )
    }

    return (
        <div>
            <GridContextProvider onChange={handleOnDragEnd}>
                <GridDropZone
                    className="dropzone left"
                    id="shortcutDashboard"
                    boxesPerRow={getGridNumberOfColumns()}
                    rowHeight={itemHeight}
                    style={{height: `${totalHeight}px`, backgroundColor: "transparent", border: "none"}}
                >
                    {shortcutsList.map((shortcut) => {
                        return (
                            <GridItem key={shortcut.getId()}>
                                <div className="grid-item">
                                    <div className="grid-item-content">
                                        {
                                            getShortcutComponentByType(shortcutType, shortcut)
                                        }
                                    </div>
                                </div>
                            </GridItem>
                        )
                    })}
                </GridDropZone>
            </GridContextProvider>
        </div>
    )
}

export default ShortcutsGrid


// WEBPACK FOOTER //
// ./src/shortcuts/sections/ShortcutsGrid.tsx